<template>
    <div>
        <el-popconfirm
            :title="$t('button.AreYouSureToDeleteThis')"
            :confirm-button-text="$t('button.Confirm')"
            :cancel-button-text="$t('button.Cancel')"
            @confirm="confirm()"
        >
            <el-button slot="reference" size="small" type="danger">{{ $t('button.Delete') }}</el-button>
        </el-popconfirm>
    </div>
</template>

<script>
export default {
    methods: {
        confirm() {
            this.$emit("confirmDelete");
        }
    },
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Button/DeleteButton.vue